// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { WizardPane } from "@/components/shared/wizard-pane";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface UnsavedChangesDialogProps {
  open: boolean;
  onStay: () => void;
  onDiscard: () => void;
}

export function UnsavedChangesDialog({ open, onStay, onDiscard }: UnsavedChangesDialogProps) {
  const { t } = useTranslation("back-office");

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onStay();
      }}
    >
      <DialogContent id="dialog-unsaved-changes" className="sm:max-w-[37rem] p-0 gap-0 overflow-hidden flex flex-col">
        <div className="flex flex-row">
          <WizardPane variant="destructive" icon={X} />
          <div className="flex-1 p-6 flex flex-col gap-4 min-w-0">
            <DialogHeader>
              <DialogTitle>{t("unsavedChanges.title")}</DialogTitle>
              <DialogDescription>{t("unsavedChanges.description")}</DialogDescription>
            </DialogHeader>
          </div>
        </div>
        <DialogFooter className="mx-0 mb-0 rounded-none rounded-b-lg">
          <Button variant="outline" onClick={onStay}>
            {t("buttons.stayOnPage")}
          </Button>
          <Button variant="destructive" onClick={onDiscard}>
            <X className="h-4 w-4" />
            {t("buttons.discardAndLeave")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
